/**
* Video Slider JS
* -----------------------------------------------------------------------------
*
* All the JS for the Video Slider component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'video-slider',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.video-slider' ).length ) {
        $( '.video-slider' ).each( function( index, element ) {
          new Splide( element, {
            type: 'loop',
            gap: '2rem',
            fixedWidth: '368px',
            perMove: 1,
            pagination: false,
            speed: 800,
            focus: 'center',
            breakpoints: {
              1269: {
                perPage: 2,
              },
              768: {
                perPage: 1,
              },
            },
          } ).mount( {} );
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'video-slider', COMPONENT );
} )( app );
